import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import { PolarisConfigFields } from '../components/PolarisConfigFields';
import { inject, observer } from 'mobx-react';

@inject('configurationStore')
@observer
class PolarisConfig extends Component {
  displayName = PolarisConfig.name;

  componentDidMount() {
    const currentCustomerId = parseInt(this.props.match.params.customerId, 10);
    this.props.configurationStore.setCurrentCustomerId(currentCustomerId);
  }
  
  render() {
    const { configurationStore, } = this.props;
    if (configurationStore.isLoading || configurationStore.currentPolarisConfig === void 0)
      return <p><em>Loading...</em></p>;

    const { 
      updatePolarisConfig,
      currentPolarisConfig,
      customer
    } = configurationStore;
    
    return (
      <div>
        <h1>{customer.name} - Polaris Config</h1>
        <Link to={`/customer/${customer.id}`} className="mr-5">
            <Glyphicon glyph="arrow-left" /> Back to Customer
        </Link>
        <hr></hr>
        <PolarisConfigFields buttonText='Update config' onSubmit={updatePolarisConfig} polarisConfig={currentPolarisConfig} configurationStore={configurationStore}/>
      </div>
    );
  }
}

export { PolarisConfig };